export default __webpack_public_path__ + "static/media/microsoft-30x30.49adb08d.svg";